var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadcount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 25,
    fill: "url(#pattern1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2598_12385",
    transform: "translate(0 0.14) scale(0.0104167 0.0075)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2598_12385",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAABwElEQVR4nO3cQU6DQABG4V/j1ngBu+7ZNU1cu/BG1aR4AFxUNw2VQhkedN6XzM4ywIu2Ap1EkiRJkiRJYm2S7JI0SdorR5PkLcl21iNYsU2Sz1x/4k/H1++21WOX6U/+33id8ThWa4o/O+fGYcbjuMgdvQMd2sLbX9Qx39M7UDsDwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAW2KA74LbXtwNmSUG+Ci47feC274Z2xxvoE99O3Kf5HnG41i1TY430A+Z5j7wSxZ68hd1f/RCffeMV3VMS3wPqIoBYAaAGQBmAJgBYAaAjQ0w5fP7Q0efufdn9u8flHp+f+1jtu8flHx+f+1j8PcPxvzb3iR5HPG6GjRJnoa8YEyAdsRrajLonPopCGYAmAFgDwW2Wfp6fN97ED3/IP4GwAwAMwDMADADwAwAMwDsXID/rvf3Of35MdfLq56fXq+n9vnx9Xpqnx9fr6eq+buum7QX7OQ1+q7VVDW/n4JgBoAZAGYAmAFgBoAZAGYAmAFgBoAZAGYAmAFgBoAZANYVgF6vp6r5uwLQ6/XUPj++Xk/t8yfh1+upfX5JkiRJkiTdoB9nac/e4zeRXAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadcount);
export default __webpack_public_path__ + "static/media/headcount.4645e05e6e8b416ab8e7427e0bdc2c3d.svg";
export { ForwardRef as ReactComponent };